import { render, staticRenderFns } from "./ContractDetailDrawer.vue?vue&type=template&id=bc3ce6f8&"
import script from "./ContractDetailDrawer.vue?vue&type=script&lang=ts&"
export * from "./ContractDetailDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports